(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7391"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7391"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3tig5", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $28723e44681442b6$export$6503ec6e8aabbaf; }, function (v) { return $28723e44681442b6$export$6503ec6e8aabbaf = v; });
var $28723e44681442b6$export$6503ec6e8aabbaf;
var $28723e44681442b6$export$f7ad0328861e2f03;
"use strict";
var $28723e44681442b6$var$mapping = new Map();
function $28723e44681442b6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$28723e44681442b6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $28723e44681442b6$var$resolve(id) {
    var resolved = $28723e44681442b6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$28723e44681442b6$export$6503ec6e8aabbaf = $28723e44681442b6$var$register;
$28723e44681442b6$export$f7ad0328861e2f03 = $28723e44681442b6$var$resolve;

});

parcelRegister("hKR6R", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $cecfedfe58011b9b$export$bdfd709ae4826697; }, function (v) { return $cecfedfe58011b9b$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $cecfedfe58011b9b$export$5a759dc7a1cfb72a; }, function (v) { return $cecfedfe58011b9b$export$5a759dc7a1cfb72a = v; });
var $cecfedfe58011b9b$export$bdfd709ae4826697;
var $cecfedfe58011b9b$export$c9e73fbda7da57b6;
var $cecfedfe58011b9b$export$5a759dc7a1cfb72a;
"use strict";
var $cecfedfe58011b9b$var$bundleURL = {};
function $cecfedfe58011b9b$var$getBundleURLCached(id) {
    var value = $cecfedfe58011b9b$var$bundleURL[id];
    if (!value) {
        value = $cecfedfe58011b9b$var$getBundleURL();
        $cecfedfe58011b9b$var$bundleURL[id] = value;
    }
    return value;
}
function $cecfedfe58011b9b$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $cecfedfe58011b9b$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $cecfedfe58011b9b$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $cecfedfe58011b9b$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$cecfedfe58011b9b$export$bdfd709ae4826697 = $cecfedfe58011b9b$var$getBundleURLCached;
$cecfedfe58011b9b$export$c9e73fbda7da57b6 = $cecfedfe58011b9b$var$getBaseURL;
$cecfedfe58011b9b$export$5a759dc7a1cfb72a = $cecfedfe58011b9b$var$getOrigin;

});

var $2638948b56e65e9b$exports = {};


(parcelRequire("3tig5")).register((parcelRequire("hKR6R")).getBundleURL("kXHk2"), JSON.parse('["kXHk2","index.9b090ff7.js","4cvKi","ticker.7b56a5df.js","bGRlQ","index.7df55e91.css"]'));

})();
//# sourceMappingURL=index.runtime.b327ccf6.js.map
